export const TravelStartTabs = {
  HOTELS: "hotels",
  CARS: "cars",
  ACTIVITIES: "activities",
  FLIGHTS: "flights",
  THEMEPARKS: "theme-parks",
  PARKS: "parks",
  EVENTS: "events",
  CRUISE: "cruise",
};
